import { RootState } from '../store';

export const selectLastMovieAdded = (state: RootState) =>
  state.movie.lastMovieAdded;
export const selectAddMovieLoading = (state: RootState) =>
  state.movie.addMovieLoading;
export const selectAddMovieError = (state: RootState) =>
  state.movie.addMovieError;
